<template>
  <span>
    <template v-if="isButton">

      <!-- Button container mode -->
      <button :type="buttonType" :class="containerClass" :disabled="isCounting">
        {{ displayedText }}
      </button>

    </template>
    <template v-else>

      <!-- Link container mode -->
      <a :href="linkHref" :class="containerClass + (isCounting ? ' disabled' : '')">
        {{ displayedText }}
      </a>

    </template>
  </span>
</template>

<script>
export default {

  /**
   * Input properties
   */
  props: {
    // Time left for blocking the button and showing the countdown, in seconds.
    timeLeft: {
      type: Number,
      default: 0
    },

    // Link/button countdown text.
    countdownText: {
      type: String,
      // The [s] literal will be replaced with real second value.
      default: "Seconds left: [s]"
    },

    // Link/button text when countdown finished.
    text: {
      type: String,
      default: "Done"
    },

    // Determines that countdown container is a button. If false, the container would be rendered as a link.
    isButton: {
      type: Boolean,
      default: true,
    },

    // Button type, if the container is a button.
    buttonType: {
      type: String,
      default: "button"
    },

    // Link location href, if the container is a link.
    linkHref: {
      type: String,
      default: "#"
    },

    // Container class.
    containerClass: {
      type: String,
      default: "btn btn-default"
    },
  },

  /**
   * Variables (models)
   */
  data () {
    return {
      seconds: this.timeLeft,
      timerId: 0,
    }
  },

  computed: {
    isCounting() {
      return this.seconds > 0;
    },

    displayedText() {
      if (!this.isCounting) return this.text;
      return this.countdownText.replace('[s]', this.seconds);
    }
  },

  methods: {
    finish() {
      clearInterval(this.timerId);
    }
  },

  mounted () {
    if (this.isCounting) {
      this.timerId = setInterval(() => {
        this.seconds--;
        if (this.seconds <= 0) {
          this.finish();
        }
      }, 1000);
    }
  },

  unmounted () {
    this.finish();
  }
}
</script>

<style scoped>

</style>
